import {
    Table,
    TableColumn,
    TableRow,
    TableHeaderTheme,
    TableRowTheme,
    TableBorderRadius,
    TableBorderStyle,
    TableRowSeperatorStyle,
} from '@apply/components';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { formatExperienceAddress } from '../../constants/formatExperienceAddress';
import { VerificationStatusIconCell } from '../../components/cells/VerificationStatusIconCell';
import { ExperienceType, ExperienceVerificationStatusType } from '@apply/constants';
import { formatProjectType } from '../../constants/formatProjectType';
import { isMobileScreen } from '@apply/ui';

export interface BFITableProps {
    experiences: UserExperienceDto[];
}

export const BFITable: React.FC<BFITableProps> = ({ experiences }) => {
    const mobileScreen = isMobileScreen();
    const renderExperienceStatusIcon = (verificationStatusType: ExperienceVerificationStatusType) => {
        return <VerificationStatusIconCell experienceStatusTypeId={verificationStatusType} />;
    };

    const data: TableRow[] = experiences
        .filter((f) => f.experienceTypeId !== ExperienceType.NonBfi)
        .map((experience) => {
            return {
                rowNumber: experience.rowNumber,
                experienceStatusIcon: renderExperienceStatusIcon(experience.verificationStatusTypeId),
                propertyAddress: formatExperienceAddress(experience),
                projectType: formatProjectType(experience.projectTypeId),
            };
        });

    return (
        <>
            {mobileScreen && (
                <>
                    <br />
                    <h3>BFI Experience</h3>
                    <br />
                </>
            )}
            <Table
                headerTheme={TableHeaderTheme.Green}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                rowSeperatorStyle={TableRowSeperatorStyle.Medium}
                showHeader={true}
                data={data}
                width='100%'
                enablePaging={true}
                minimumHeaderHeight={50}
                minimumRowHeight={50}
                emptyTableText='No BFI Experience Found'
                emptyTableTextAlign='left'
            >
                <TableColumn
                    columnKey='rowNumber'
                    visible={true}
                    width='3%'
                    header={mobileScreen ? 'Number' : ''}
                    center={!mobileScreen}
                />
                <TableColumn
                    columnKey='projectType'
                    width='25%'
                    visible={true}
                    header='Project Type'
                />
                <TableColumn
                    columnKey='propertyAddress'
                    header='Address'
                    width='70%'
                    visible={true}
                />
            </Table>
        </>
    );
};
